import { createFileRoute } from "@tanstack/react-router";
import { TeamsTable } from "@/app/partner/pages/teams";

export const Route = createFileRoute("/flex/dashboard/teams")({
	component: TeamsPage,
});

function TeamsPage() {
	return <TeamsTable />;
}
